import styled from 'styled-components'

export const NissanCustomStyle = styled.div``
